import React from 'react'

const Unauthorized = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="text-center mt-5">
            <h1>Sidan kan inte visas</h1>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 text-center">
                    Du har ej behörighet att besöka den här sidan.
        </div>
      </div>
    </div>
  )
}

export default Unauthorized
